const styles = {
  root: {
    overflow: 'hidden',
    backgroundColor: 'background.tile',
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    borderRadius: 1,
    height: { xs: '56px', md: 'auto' },
    padding: 0,
    '&.MuiButtonBase-root': {
      borderRadius: (theme) => `${theme.spacing(0.5)}!important`,
    },
    '&.flexible': {
      flexDirection: {
        xs: 'row', sm: 'column',
      },
    },

    '&.row': {
      flexDirection: 'row',
    },

    '&.column': {
      flexDirection: 'column',
    },

    '&.selected': {
      backgroundColor: 'primary.main',
      color: 'secondary.contrastText',
    },
  },

  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 1,
    '&.row': {
      alignItems: 'center',
    },
  },

  transparentIcon: {
    borderRight: '1px solid background.default',
  },

  textContainer: {
    flexGrow: 1,
    padding: '5px 10px',
    textAlign: 'left',
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& *': {
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },

  textContainerRow: {

  },
}

export default styles
